import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import ProductCard from './ProductList';
import Carousel from '../components/slides/Carousel';
import Footer from '../components/header_footer/Footer';
import '../App.css';
import './Home.css';

// Move ProductFilterBar outside Home
function ProductFilterBar({ filters, activeFilter, setActiveFilter }) {
  return (
    <div className="filter-container">
      {filters.map((filter) => (
        <button
          key={filter.key}
          className={`filter-btn${activeFilter === filter.key ? " active" : ""}`}
          onClick={() => setActiveFilter(filter.key)}
        >
          {filter.label}
        </button>
      ))}
    </div>
  );
}

// Move generateFiltersFromProducts outside Home
function generateFiltersFromProducts(products, setFilters) {
  if (!Array.isArray(products)) {
    setFilters([{ key: "all", label: "All Products" }]);
    return;
  }
  const filterMap = new Map();
  products.forEach((product) => {
    if (product.name) {
      const words = product.name.split(" ");
      const label = words.slice(0, 2).join(" ").toLowerCase();
      if (!filterMap.has(label)) {
        // Capitalize each word in the label
        const capitalizedLabel = label
          .split(" ")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
        filterMap.set(label, capitalizedLabel);
      }
    }
  });
  setFilters([
    { key: "all", label: "All Products" },
    ...Array.from(filterMap.entries()).map(([key, label]) => ({
      key,
      label,
    })),
  ]);
}

const Home = ({ search }) => {
  const products = useSelector(state => state.products.items);
  const [activeFilter, setActiveFilter] = useState("all");
  const [filters, setFilters] = useState([{ key: "all", label: "All Products" }]);

  // Update filters whenever products change
  useEffect(() => {
    generateFiltersFromProducts(products, setFilters);
    // eslint-disable-next-line
  }, [products]);

  // Filter logic: filter by activeFilter and search text
  const filteredProducts = products.filter((p) => {
    const matchesFilter =
      activeFilter === "all" ||
      (p.name || "").toLowerCase().includes(activeFilter.toLowerCase());
    const matchesSearch =
      search.trim() === "" ||
      (p.name || "").toLowerCase().includes(search.trim().toLowerCase()) ||
      (p.description || "").toLowerCase().includes(search.trim().toLowerCase());
    return matchesFilter && matchesSearch;
  });

  return (
    <>
      <Carousel />
      <section className="products-section" id="products">
        <div className="section-header">
          <h2 className="section-title">Our Products</h2>
          <p className="section-subtitle">Premium paper bags for every need</p>
          <ProductFilterBar filters={filters} activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
        </div>

        <div className="products-grid">
          {filteredProducts.map((p, idx) => (
            <ProductCard key={idx} product={p} />
          ))}
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Home;

